
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSleetShowersPolartwilightColour as ObiLightningSleetShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-sleet-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiLightningSleetShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-sleet-showers-polartwilight-colour',
   elementClass: ObiLightningSleetShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 